import { useQuery } from "@tanstack/react-query";

import { getEncounterWriteBacks } from "@/api/writeBackManagement";

export function useEncounterWriteBacks(encounterId: string | null) {
  return useQuery({
    queryKey: ["encounter-write-backs", encounterId],
    queryFn: () => getEncounterWriteBacks(encounterId!),
    enabled: encounterId !== null,
    retry: false,
  });
}
